// @ts-nocheck



import React from 'react';


import { expenseDirectionApi } from './../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';



export default class extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.value !== this.props.value;
  }

  render() {
    const { filter, optionKey, ...selectProps } = this.props;
    return (
      <AutocompleteSelect
        fetch={async (params) => {
          return await expenseDirectionApi.fetchExpenseDirection({
            ...filter,
            ...params
          });
        }}
        refetchParams={{ filter }}
        fetchSingle={expenseDirectionApi.fetchExpenseDirection}
        notFoundText="Наименование не найдено"
        placeholder="Выберите наименование расхода"
        renderOption={(expenseDirection, Option) =>
        <Option
          key={`${optionKey}${expenseDirection.id}`}
          value={expenseDirection.id}>

            {expenseDirection.name}
          </Option>
        }
        {...selectProps} />);


  }
}
